// Puts a presenter together from what the visitor chose (and what the server saved), the same way for the live preview and for the studio.
import { PRESENTERS, PRESENTER_IDS } from "./presenters";
import { DEFAULT_MARKS, faceGeometry, marksAreValid, sampleSkin } from "./puppet";
import { DEFAULT_STAGE } from "./stage";

export const SPEAKING_WORDS_PER_MINUTE = 150;

// How long a script takes to say, in seconds (a rough guide shown while the visitor writes).
export function speakingSeconds(text) {
  const words = String(text || "").trim().split(/\s+/).filter(Boolean).length;
  return Math.round((words / SPEAKING_WORDS_PER_MINUTE) * 60);
}

export const formatDuration = (seconds) => (seconds < 60 ? `${seconds} s` : `${Math.floor(seconds / 60)} min ${String(seconds % 60).padStart(2, "0")} s`);

// avatar: { type: "builtin" | "photo", presenter, marks, stage, name, role } as the server stores it.
// img: the loaded photo (for type "photo"); bg: the loaded stage picture (for the "image" stage); hasAlpha: the photo is a cut-out with a transparent background.
export function buildPresenter(avatar, { img = null, bg = null, hasAlpha = false, seed = 1 } = {}) {
  const stage = { ...DEFAULT_STAGE, ...(avatar.stage || {}) };
  const common = { stage, bg, name: avatar.name || "", role: avatar.role || "", seed };
  if (avatar.type === "photo" && img) {
    const marks = marksAreValid(avatar.marks) ? avatar.marks : DEFAULT_MARKS;
    const geometry = faceGeometry(marks, img.naturalWidth || img.width, img.naturalHeight || img.height);
    return { ...common, kind: "photo", img, geometry, skin: sampleSkin(img, geometry), hasAlpha };
  }
  return { ...common, kind: "builtin", spec: PRESENTERS[avatar.presenter] || PRESENTERS[PRESENTER_IDS[0]] };
}

// Whether a stored picture address is a cut-out (the server keeps only transparent photos as PNG files).
export const isCutout = (url) => /\.png(\?|$)/i.test(String(url || ""));
